import { useAppConfig } from "@/api/app-config/useAppConfig";

// NOTE: NSAI-3306 — true when IS_SKILLS_ENABLED is "true" on the server. Read
// from the public /app-config endpoint, the same way every other feature flag
// reaches the UI. The backend enforces the flag on its own routes, so this only
// decides whether the surface is shown — never whether access is allowed.
export const useSkillsEnabled = (): boolean => {
  const { data } = useAppConfig();
  return data?.isSkillsEnabled ?? false;
};
